/* custom-sdl.js — v2.6
 * 只寫 SDL 的「Grid Pattern」，嚴格排除 GBG；Remark 更精準；並防呆清掉被誤填的 GBG 值
 */
(function(){
  if (window.__CUSTOM_SDL_COMPLETE_LOADED_V26__) return;
  window.__CUSTOM_SDL_COMPLETE_LOADED_V26__ = true;

  const QTY_SELECTOR = 'input[name="quantity"], input#Quantity, input.quantity__input';
  const FORM_SELECTOR = 'form[action*="/cart"][method="post"], form.product-form, form[action="/cart/add"]';
  const WARNING_TEXT = 'W × H must equal the selected SDL quantity.';
  const DBG = localStorage.getItem('sdl_dbg') === '1';
  const log = (...a)=>{ if (DBG) console.log('[custom-sdl]', ...a); };

  const q=(s,c=document)=> (c||document).querySelector(s);
  const qa=(s,c=document)=> Array.from((c||document).querySelectorAll(s));
  const textOf=(el)=> el ? String(el.textContent||'').trim() : '';
  const L=(s)=> (s||'').toString().toLowerCase();
  const toInt=(v)=>{ const n = parseInt(String(v||'').trim(),10); return Number.isFinite(n)? n : NaN; };

  /* ---------- 找 SDL 區塊 ---------- */
  function findSDLStack(){
    const stacks = qa('.po-stack, .po-option--container, .po-option-container, .product-options, .product-form .options, .field');
    for (const st of stacks){
      const lab = st.querySelector('.po-label, .po-option-label, label, h3, h4, strong, span');
      if (lab && /\bSDL\b/i.test(textOf(lab))) return st;
    }
    for (const n of qa('label,span,div,strong')){
      if (/\bSDL\b/i.test(textOf(n))){
        return n.closest('.po-stack, .po-option--container, .po-option-container') || n.closest('div');
      }
    }
    return null;
  }

  /* ---------- 嚴格鎖定「SDL 的 Grid Pattern 欄位」 ---------- */
  function isGBGish(el){
    const bagSelf = [el.name, el.id, el.placeholder, el.className, el.getAttribute?.('aria-label')]
      .map(L).join(' ');
    if (/\bgbg\b/.test(bagSelf)) return true;

    let p = el.parentElement, depth = 0;
    while (p && depth < 6){
      if (/\bgbg\b/i.test(textOf(p))) return true;
      if (p.matches?.('.po-stack, .po-option--container, .po-option-container, .field, .product-option, .bss-po-option')) break;
      p = p.parentElement; depth++;
    }
    return false;
  }
  function hasGridPatternHints(el){
    let bag = [el.name, el.id, el.placeholder, el.className, el.getAttribute?.('aria-label')]
      .map(L).join(' ');
    try{
      if (el.labels?.length){
        bag += ' ' + Array.from(el.labels).map(l => L(l.textContent)).join(' ');
      }
    }catch(_){}
    const wrap = el.closest('.po-option, .po-option--container, .po-option-container, .po-stack, .field, .product-option, .bss-po-option, [role="group"]');
    if (wrap) bag += ' ' + L(textOf(wrap));
    return /\bgrid\b/.test(bag) && /\bpattern\b/.test(bag);
  }
  function nameIsGridPattern(el){
    return /\bproperties\[\s*grid\s*pattern\s*\]/i.test(el.getAttribute?.('name')||'');
  }
  function pickClosestToStack(list, stack){
    if (!stack?.getBoundingClientRect) return list[0];
    const s = stack.getBoundingClientRect();
    let best = {d:Infinity, el:list[0]};
    list.forEach(el=>{
      try{
        const r = el.getBoundingClientRect();
        const d = Math.abs((r.top + r.bottom)/2 - (s.top + s.bottom)/2)
                + Math.abs((r.left + r.right)/2 - (s.left + s.right)/2) * 0.2;
        if (d < best.d) best = {d, el};
      }catch(_){}
    });
    return best.el;
  }
  function findSDLGridPatternField(SDLStack){
    const allInputs = qa('textarea, input[type="text"], input:not([type])');

    // 1) name 精準命中 + 排除 GBG
    const exact = allInputs.filter(el => nameIsGridPattern(el) && !isGBGish(el));
    if (exact.length) return pickClosestToStack(exact, SDLStack);

    // 2) SDL 區塊內的語意命中 + 排除 GBG
    if (SDLStack){
      const inStack = qa('textarea, input[type="text"], input:not([type])', SDLStack)
        .filter(el => hasGridPatternHints(el) && !isGBGish(el));
      if (inStack.length) return inStack[0];
    }

    // 3) 隔壁區塊
    const sib = SDLStack?.nextElementSibling;
    if (sib){
      const around = qa('textarea, input[type="text"], input:not([type])', sib)
        .filter(el => hasGridPatternHints(el) && !isGBGish(el));
      if (around.length) return around[0];
    }

    // 4) 最後全頁 fallback（仍排除 GBG）
    const all = allInputs.filter(el => hasGridPatternHints(el) && !isGBGish(el));
    if (all.length) return pickClosestToStack(all, SDLStack);

    return null;
  }

  /* ---------- 數量讀取 ---------- */
  function findNearestQtyEl(scope){
    try{
      const targets = qa('[role="spinbutton"], input[type="number"], .quantity, .qty');
      if (!targets.length) return q(QTY_SELECTOR) || null;
      const rect = scope?.getBoundingClientRect?.() || {top:0,bottom:0};
      let best = {d:Infinity, el:null};
      targets.forEach(el=>{
        try{
          const r = el.getBoundingClientRect();
          const d = Math.abs((r.top + r.bottom)/2 - (rect.top + rect.bottom)/2);
          if (d < best.d) best = {d, el};
        }catch(_){}
      });
      return best.el || q(QTY_SELECTOR) || null;
    }catch(_){ return q(QTY_SELECTOR) || null; }
  }
  function qtyFromNxSDL(scope){
    if (!scope) return 0;
    const nodes = qa('a,span,div,button,small,em,strong,label', scope).concat([scope]);
    for(const el of nodes){
      const m = (textOf(el)).match(/(\d+)\s*x\s*sdl/i);
      if (m) return parseInt(m[1],10) || 0;
    }
    return 0;
  }
  function qtyFromNearestSpin(stack){
    const el = findNearestQtyEl(stack);
    if (!el) return 0;
    if (el.matches && el.matches('input')) {
      const v = parseInt(String(el.value || el.getAttribute('aria-valuenow') || '').trim(), 10);
      return Number.isFinite(v) ? v : 0;
    }
    const m = (textOf(el)).match(/-?\d+/);
    return m ? (parseInt(m[0],10) || 0) : 0;
  }
  function readSDLQty(stack){
    const n = qtyFromNxSDL(stack) || 0;
    if (n > 0) return n;
    const s = qtyFromNearestSpin(stack) || 0;
    if (s > 0) return s;
    const globalQty = q(QTY_SELECTOR);
    if (globalQty) {
      const v = parseInt(String(globalQty.value || globalQty.getAttribute('aria-valuenow') || '').trim(), 10);
      return Number.isFinite(v) ? v : 0;
    }
    return 0;
  }

  /* ---------- Remark 與 properties（更嚴格） ---------- */
  function findRemarkTextareas(scope){
    const inScope = scope ? qa('textarea', scope) : [];
    const all = qa('textarea');
    const judge = (ta)=>{
      const bag = L(
        [ta.name, ta.id, ta.placeholder, ta.className, ta.getAttribute?.('aria-label')].join(' ')
      );
      if (/\bremark\b/.test(bag)) return true;
      // 鄰近標籤含 remark
      const cont = ta.closest('.po-option--container, .po-option-container, .po-stack, .field, .product-options') || ta.parentElement;
      const lab  = cont && cont.querySelector('.po-label, label, .po-label-container, .po-helptext-content');
      if (lab && /\bremark\b/i.test(textOf(lab))) return true;
      return false;
    };
    const arr = [...inScope, ...all].filter(judge);
    // 去重
    return arr.filter((v,i,a)=>a.indexOf(v)===i);
  }

  function upsertRemarkAndHidden(form, plainLine){
    try{
      // 只對「真正的 Remark 欄」動手
      const remarkAreas = findRemarkTextareas(form);
      remarkAreas.forEach(ta=>{
        const cur = String(ta.value || '').trim();
        const lines = cur ? cur.split(/\r?\n/) : [];
        let replaced = false;
        for (let i=0;i<lines.length;i++){
          if (/^\s*\d+\s*W\s*x\s*\d+\s*H\s*$/i.test(lines[i]) || /^\s*SDL\s*Pattern\s*:/.test(lines[i])) {
            lines[i] = plainLine; replaced = true; break;
          }
        }
        if (!replaced) lines.push(plainLine);
        ta.value = lines.join('\n');
        ta.dispatchEvent(new Event('input',{bubbles:true}));
        ta.dispatchEvent(new Event('change',{bubbles:true}));
      });

      // hidden properties[Remark]
      if (!form) form = q('form') || document;
      let hidden = form.querySelector('textarea[name="properties[Remark]"], input[name="properties[Remark]"], input[name="properties[REMARK]"]');
      if (!hidden) {
        hidden = qa('input,textarea', form).find(el=> /\bproperties\[(remark|REMARK)\]/i.test(el.getAttribute('name')||''));
      }
      if (!hidden) {
        hidden = document.createElement('textarea');
        hidden.name = 'properties[Remark]';
        hidden.style.display = 'none';
        (form || document.body).appendChild(hidden);
      }
      const cur = String(hidden.value || '').trim();
      const lines = cur ? cur.split(/\r?\n/) : [];
      let replaced = false;
      for (let i=0;i<lines.length;i++){
        if (/^\s*\d+\s*W\s*x\s*\d+\s*H\s*$/i.test(lines[i]) || /^\s*SDL\s*Pattern\s*:/.test(lines[i])) {
          lines[i] = plainLine; replaced = true; break;
        }
      }
      if (!replaced) lines.push(plainLine);
      hidden.value = lines.join('\n');
      hidden.dispatchEvent(new Event('input',{bubbles:true}));
      hidden.dispatchEvent(new Event('change',{bubbles:true}));
    }catch(e){ log('remark/hidden err', e); }
  }

  function ensureProperty(key, value){
    try{
      const form = q(FORM_SELECTOR) || q('form') || document;
      if (!form) return;
      const name = `properties[${key}]`;
      let el = form.querySelector(`input[name="${name}"]`);
      if (!el){
        el = document.createElement('input'); el.type = 'hidden'; el.name = name;
        (form || document.body).appendChild(el);
      }
      el.value = value;
      el.dispatchEvent(new Event('change',{bubbles:true}));
    }catch(e){ log('ensureProperty err', e); }
  }

  /* ---------- 防呆：若 GBG 欄被誤填，同步清空 ---------- */
  function clearGBGEcho(plainLine){
    const gbgBoxes = qa('textarea, input[type="text"], input:not([type])').filter(el=>{
      const bag = L([el.name, el.id, el.placeholder, el.className, el.getAttribute?.('aria-label')].join(' '));
      if (!/\bgbg\b/.test(bag)) return false;
      // 排除非文本型欄位
      if (el.tagName !== 'TEXTAREA' && !(el.tagName === 'INPUT')) return false;
      return true;
    });
    // 若 GBG 選項有 checkbox，僅在「未勾選」時清空
    let gbgChecked = false;
    const gbgChk = qa('input[type="checkbox"], input[type="radio"]').find(inp=>{
      const labTxt = (inp.labels && Array.from(inp.labels).map(l=>textOf(l)).join(' ')) || '';
      return /\bgbg\b/i.test(labTxt) || /\bgbg\b/i.test(textOf(inp.closest('.po-stack, .po-option--container, .po-option-container, .field')||{}));
    });
    if (gbgChk) gbgChecked = !!gbgChk.checked;

    if (!gbgChecked){
      gbgBoxes.forEach(el=>{
        try{
          if (String(el.value||'').trim() === plainLine){
            el.value = '';
            el.dispatchEvent(new Event('input',{bubbles:true}));
            el.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }catch(_){}
      });
    }
  }

  /* ---------- UI 與掛載 ---------- */
  function makeMiniUI(){
    let mini = q('#sdl-mini');
    if (mini) return mini;
    mini = document.createElement('div');
    mini.id = 'sdl-mini';
    mini.style.cssText = 'margin-top:12px; display:inline-block; vertical-align:top;';
    const box = document.createElement('div');
    box.style.cssText = 'display:inline-block;border-radius:10px;border:1px solid #e6dddd;padding:10px;background:transparent;';
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:nowrap;white-space:nowrap;';
    const w = document.createElement('input'); w.type='text'; w.className='sdl-w'; w.placeholder='W'; w.style.cssText='width:72px;padding:6px;border-radius:8px;border:1px solid #ddd;';
    const x = document.createElement('span'); x.textContent='×'; x.style.fontWeight='600';
    const h = document.createElement('input'); h.type='text'; h.className='sdl-h'; h.placeholder='H'; h.style.cssText='width:72px;padding:6px;border-radius:8px;border:1px solid #ddd;';
    const btn = document.createElement('button'); btn.type='button'; btn.className='sdl-apply'; btn.textContent='Apply';
    btn.style.cssText = 'padding:6px 10px;border-radius:8px;border:1px solid #ccc;background:#fff;cursor:pointer;';
    const msg = document.createElement('div'); msg.className='sdl-msg'; msg.style.cssText='color:#b91c1c;font-size:13px;margin-top:8px;display:none;';
    row.appendChild(w); row.appendChild(x); row.appendChild(h); row.appendChild(btn);
    box.appendChild(row); box.appendChild(msg); mini.appendChild(box);
    return mini;
  }

  function findProductForm(stack){
    try{
      if (stack?.closest) {
        const f = stack.closest('form');
        if (f) return f;
      }
      const addBtns = qa('form button[type="submit"], form input[type="submit"], form [data-add-to-cart], form .add-to-cart');
      if (addBtns.length) return addBtns[0].closest('form');
      return q('form[action*="/cart/add"], form.product-form') || q('form') || null;
    }catch(_){ return q(FORM_SELECTOR) || q('form') || null; }
  }

  function showVisibleRemark(form, line){
    // 若頁面有底部 remark 欄，使用者會在那看到；不另外產生提示
  }

  function mountOnce(){
    const st = findSDLStack();
    if (!st) { log('SDL stack not found'); return; }

    let mini = q('#sdl-mini');
    if (!mini){ mini = makeMiniUI(); st.insertAdjacentElement('afterend', mini); }
    else if (mini.parentElement !== st.parentElement || mini.previousElementSibling !== st){
      st.insertAdjacentElement('afterend', mini);
    }

    const checkbox = st.querySelector('input[type="checkbox"]');
    mini.style.display = (checkbox && checkbox.checked) ? '' : 'none';
    if (checkbox && !checkbox.__sdlBound){
      checkbox.addEventListener('change', ()=> { mini.style.display = checkbox.checked ? '' : 'none'; });
      checkbox.__sdlBound = true;
    }

    const wEl = mini.querySelector('.sdl-w');
    const hEl = mini.querySelector('.sdl-h');
    const btn = mini.querySelector('.sdl-apply');
    const msg = mini.querySelector('.sdl-msg');
    [wEl,hEl].forEach(el=> el && el.addEventListener('input', ()=>{ msg.style.display='none'; }, {passive:true}));

    if (btn && !btn.__wired){
      btn.addEventListener('click', function(ev){
        try{
          const W = toInt(wEl.value), H = toInt(hEl.value);
          const hasW = Number.isFinite(W) && W>0;
          const hasH = Number.isFinite(H) && H>0;
          const qty = readSDLQty(st);

          if (qty > 0 && hasW && hasH && (W * H !== qty)){
            msg.style.display=''; msg.textContent = `${WARNING_TEXT} (${qty})`;
            msg.setAttribute('role','alert'); msg.setAttribute('aria-live','assertive');
            ev.preventDefault(); ev.stopImmediatePropagation(); return false;
          }

          if (hasW && hasH){
            const line = `${W} W x ${H} H`;

            // 只寫 SDL 的 Grid Pattern 欄位
            const gridField = findSDLGridPatternField(st);
            if (gridField){
              gridField.value = line;
              gridField.dispatchEvent(new Event('input',{bubbles:true}));
              gridField.dispatchEvent(new Event('change',{bubbles:true}));
              log('wrote -> SDL Grid Pattern', gridField);
            } else {
              log('SDL Grid Pattern field NOT found');
            }

            // remark & properties
            const form = findProductForm(st);
            upsertRemarkAndHidden(form, line);
            ensureProperty('SDL Pattern (grids)', line);
            ensureProperty('SDL W (grids)', String(W));
            ensureProperty('SDL H (grids)', String(H));
            showVisibleRemark(form, line);

            // 保險：若 GBG 欄被別的腳本同步了，且 GBG 未勾選，清掉
            clearGBGEcho(line);

            const prev = btn.textContent; btn.textContent = 'Applied';
            setTimeout(()=> btn.textContent = prev || 'Apply', 700);
            msg.style.display='none';
          }
        }catch(err){ log('apply handler err', err); }
      }, {capture:false});
      btn.__wired = true;
    }
  }

  function scan(){ try{ mountOnce(); }catch(e){ log('scan err', e); } }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  try{
    const mo = new MutationObserver(()=> setTimeout(scan, 80));
    mo.observe(document.documentElement||document.body, {childList:true, subtree:true});
  }catch(_){}

  window.__custom_sdl = window.__custom_sdl || {};
  window.__custom_sdl.scan = scan;
  log('custom-sdl loaded v2.6');
})();
